export const EVALUATOR_ROLES = {
  RESIDENT: 'Resident',
  MANAGER: 'Manager',
  NURSE: 'Nurse',
  PACIENT: 'Pacient',
  LECTURER: 'Lecturer'
};